import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import AppContext from '@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { showLoader } from '../../../redux/actions/NotifyActions';
import {
  reportSummaryOverviewFetch,
  reportSummaryOverviewFetchReset,
  reportSummaryFactorFetch,
  reportSummaryFactorFetchReset,
  reportSummaryCarModelFetch,
  reportSummaryCarModelFetchReset,
  reportCustomerVoiceFetch,
  reportCustomerVoiceFetchReset,
  reportRankingFetch,
  reportRankingFetchReset,
} from '../../../redux/actions/ReportActions';
import { renderFields, insertOptions, updateProperties } from '../../../util/formUtil';
import { filterFormFields } from '../formFields';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import { Grid, Box, Button } from '@material-ui/core';
import { DEALER, ROOT } from '../../../constants/Systems';
import moment from 'moment';
import _ from 'lodash';

class FilterForm extends Component {
  static contextType = AppContext;
  static headoffices = [];
  static branchs = [];
  static regions = [];
  static areas = [];
  static provinces = [];

  setDefaultFilter(prevProps) {
    const { change, formValues, authUser } = this.props;
    if (prevProps) {
      const { formValues: prevformValues } = prevProps;
      let dealer_code = authUser && authUser.type == DEALER ? '' : 'all';

      if (formValues && prevformValues && formValues.dealer.region != prevformValues.dealer.region) {
        change('dealer.area', 'all');
        change('dealer.province', 'all');
        change('dealer.ho_code', 'all');
        change('dealer_code', dealer_code);
      } else if (formValues && prevformValues && formValues.dealer.area != prevformValues.dealer.area) {
        change('dealer.province', 'all');
        change('dealer.ho_code', 'all');
        change('dealer_code', dealer_code);
      } else if (formValues && prevformValues && formValues.dealer.province != prevformValues.dealer.province) {
        change('dealer.ho_code', 'all');
        change('dealer_code', dealer_code);
      } else if (formValues && prevformValues && formValues.dealer.ho_code != prevformValues.dealer.ho_code) {
        change('dealer_code', dealer_code);
      }
    }
    // if (this.headoffices.length == 1) {
    //   change('dealer.ho_code', this.headoffices[0].id);
    // }
    // if (this.branchs.length == 1 ) {
    //   change('dealer_code', this.branchs[0].id);
    // }
    // if (this.regions.length == 1 ) {
    //   change('dealer.region', this.regions[0].id);
    // }
    // if (this.areas.length == 1) {
    //   change('dealer.area', this.areas[0].id);
    // }
    // if (this.provinces.length == 1) {
    //   change('dealer.province', this.provinces[0].id);
    // }
  }

  componentDidMount() {
    this.setDefaultFilter();
  }

  componentDidUpdate(prevProps) {
    this.setDefaultFilter(prevProps);
  }

  componentWillUnmount() {}

  render() {
    const { locale } = this.context;
    const { location, formValues, handleSubmit, reset, dealers, authUser } = this.props;

    let filterParams = _.omitBy(
      {
        ho_code:
          _.has(formValues, 'dealer.ho_code') && formValues.dealer.ho_code != 'all' ? formValues.dealer.ho_code : undefined,
        dealer_code:
          _.has(formValues, 'dealer_code') && formValues.dealer_code != 'all'
            ? formValues.dealer_code.split('|')[1]
            : undefined,
        region:
          _.has(formValues, 'dealer.region') && formValues.dealer.region != 'all' ? formValues.dealer.region : undefined,
        area: _.has(formValues, 'dealer.area') && formValues.dealer.area != 'all' ? formValues.dealer.area : undefined,
        province_2:
          _.has(formValues, 'dealer.province') && formValues.dealer.province != 'all'
            ? formValues.dealer.province
            : undefined,
      },
      _.isUndefined,
    );

    // // HEAD OFFICES
    let headoffices = _.orderBy(dealers, ['ho_code'], ['asc']);
    headoffices = _.filter(headoffices, element => element.ho_code == element.dealer_code);
    headoffices =
      _.has(formValues, 'dealer_code') && formValues.dealer_code != 'all' && formValues.dealer_code != ''
        ? _.filter(headoffices, { ho_code: formValues.dealer_code.split('|')[0] })
        : headoffices;
    headoffices = _.filter(headoffices, _.pick(filterParams, ['region', 'area', 'province_2']));
    this.headoffices = headoffices.map(element => {
      let { ho_code, dealer_name_th, dealer_name_en } = element;
      let dealer_name = locale.locale == 'en' ? dealer_name_en : dealer_name_th;
      let dealer_name_ = <IntlMessages id="dealer.display" values={{ dealer_code: ho_code, dealer_name }} />;
      return { id: ho_code, dealer_name_ };
    });

    // BRANCHS
    let branchs = _.orderBy(dealers, ['dealer_code'], ['asc']);
    branchs = _.filter(branchs, _.pick(filterParams, ['ho_code', 'region', 'area', 'province_2']));
    this.branchs = branchs.map(element => {
      let { ho_code, dealer_code, dealer_name_th, dealer_name_en } = element;
      let dealer_name = locale.locale == 'en' ? dealer_name_en : dealer_name_th;
      let dealer_name_ = <IntlMessages id="dealer.display" values={{ dealer_code, dealer_name }} />;
      return { id: `${ho_code}|${dealer_code}`, dealer_name_ };
    });

    // REGION
    let regions = _.orderBy(dealers, ['area'], ['asc']);
    // regions = _.filter(regions, _.pick(filterParams, ['ho_code', 'dealer_code', 'area', 'province_2']));
    regions = _.filter(regions, _.pick(filterParams, []));
    regions = _.uniqBy(regions, 'region');
    this.regions = regions.map(element => {
      let { region } = element;
      let region_name = <IntlMessages id={`dealer.region.${region}`} />;
      return { id: region, region_name };
    });

    // AREA
    let areas = _.orderBy(dealers, ['area'], ['asc']);
    // areas = _.filter(areas, _.pick(filterParams, ['ho_code', 'dealer_code', 'region', 'province_2']));
    areas = _.filter(areas, _.pick(filterParams, ['region']));
    areas = _.uniqBy(areas, 'area');
    this.areas = areas.map(element => {
      let { area } = element;
      return { id: area, area };
    });

    // PROVINCE
    let provinces = _.orderBy(dealers, ['province_2'], ['asc']);
    // provinces = _.filter(provinces, _.pick(filterParams, ['ho_code', 'dealer_code', 'region', 'area']));
    provinces = _.filter(provinces, _.pick(filterParams, ['region', 'area']));
    provinces = _.uniqBy(provinces, 'province_2');
    this.provinces = provinces.map(element => {
      let { province_2 } = element;
      let province_name = <IntlMessages id={`province.${province_2}`} />;
      return { id: province_2, province_name };
    });

    // TYPE
    if (authUser && authUser._id) {
      let types = [];
      if (authUser.type == ROOT || (authUser.type != ROOT && authUser.group.ssi)) {
        types.push({
          display: <IntlMessages id="filter.type.ssi" />,
          value: 'ssi',
        });
      }
      if (authUser.type == ROOT || (authUser.type != ROOT && authUser.group.csi)) {
        types.push(
          {
            display: <IntlMessages id="filter.type.csi-pm" />,
            value: 'csi-pm',
          },
          {
            display: <IntlMessages id="filter.type.csi-gr" />,
            value: 'csi-gr',
          },
        );
      }
      if (authUser.type == DEALER) {
        updateProperties(filterFormFields, 'dealer_code', {
          required: true,
          default: { display: 'dealer.dealer_name.branch.all', value: '' },
        });
      }
      insertOptions(filterFormFields, 'type', types, 'value', 'display');
    }
    insertOptions(filterFormFields, 'dealer.ho_code', this.headoffices, 'id', 'dealer_name_');
    insertOptions(filterFormFields, 'dealer_code', this.branchs, 'id', 'dealer_name_');
    insertOptions(filterFormFields, 'dealer.region', this.regions, 'id', 'region_name');
    insertOptions(filterFormFields, 'dealer.area', this.areas, 'id', 'area');
    insertOptions(filterFormFields, 'dealer.province', this.provinces, 'id', 'province_name');

    return (
      <form>
        {renderFields(filterFormFields)}
        <Box mt={4}>
          <Grid container spacing={3}>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onClick={handleSubmit(() => {
                  this.props.showLoader();
                  this.props.reportSummaryOverviewFetchReset();
                  this.props.reportSummaryFactorFetchReset();
                  this.props.reportSummaryCarModelFetchReset();
                  this.props.reportCustomerVoiceFetchReset();
                  this.props.reportRankingFetchReset();

                  let { dealer_code, ...rest } = formValues;
                  dealer_code = dealer_code != 'all' ? dealer_code.split('|')[1] : dealer_code;
                  console.log({
                    section: 'overall',
                    ...rest,
                    dealer_code,
                  });
                  if (location.pathname == '/app/summary-report/overview') {
                    this.props.reportSummaryOverviewFetch({
                      section: 'overall',
                      ...rest,
                      dealer_code,
                    });
                  } else if (location.pathname == '/app/summary-report/factor') {
                    this.props.reportSummaryFactorFetch({
                      section: 'factor',
                      ...rest,
                      dealer_code,
                    });
                  } else if (location.pathname == '/app/summary-report/car-model') {
                    this.props.reportSummaryCarModelFetch({
                      section: 'model',
                      ...rest,
                      dealer_code,
                    });
                  } else if (location.pathname == '/app/customer-voice') {
                    this.props.reportCustomerVoiceFetch({
                      section: 'overall',
                      ...rest,
                      dealer_code,
                    });
                  } else if (location.pathname == '/app/ranking') {
                    this.props.reportRankingFetch({
                      section: 'overall',
                      ...rest,
                      dealer_code,
                    });
                  }
                })}>
                <IntlMessages id="commands.filter" />
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="secondary"
                variant="contained"
                onClick={handleSubmit(() => {
                  reset('FilterForm');
                })}>
                <IntlMessages id="commands.filter.clear" />
              </Button>
            </Grid>
          </Grid>
        </Box>
      </form>
    );
  }
}

function validate(values) {
  const errors = {};
  filterFormFields.forEach(({ name, required, type }) => {
    if (!values[name] && required) {
      errors[name] = <IntlMessages id="errors.field.required" />;
      return;
    }
  });
  return errors;
}

const mapStateToProps = ({ auth: { authUser }, form, dealer: { dealers }, report: { reportLatest } }) => {
  const formValues = form.FilterForm ? form.FilterForm.values : null;
  let month = moment().format('MM');
  let year = moment().format('YYYY');
  let batch = '4';
  if (authUser && authUser._id) {
    let type = 'ssi';
    if (authUser.type != ROOT) {
      type = authUser.group.ssi ? 'ssi' : authUser.group.csi ? 'csi-pm' : '';
    }

    if (reportLatest.auto) {
      month = reportLatest.auto.month;
      year = reportLatest.auto.year.en.toString();
      batch = reportLatest.auto.batch;
    }

    return {
      formValues,
      dealers,
      authUser,
      initialValues: {
        month,
        year,
        batch,
        dealer_code: authUser.type == DEALER ? '' : 'all',
        dealer: { ho_code: 'all', region: 'all', area: 'all', province: 'all' },
      },
      reportLatest,
    };
  }
  return { formValues, dealers, authUser, reportLatest };
};

FilterForm = reduxForm({
  validate,
  form: 'FilterForm',
  destroyOnUnmount: false,
  enableReinitialize: true,
})(FilterForm);

export default withRouter(
  connect(mapStateToProps, {
    showLoader,
    reportSummaryOverviewFetch,
    reportSummaryOverviewFetchReset,
    reportSummaryFactorFetch,
    reportSummaryFactorFetchReset,
    reportSummaryCarModelFetch,
    reportSummaryCarModelFetchReset,
    reportCustomerVoiceFetch,
    reportCustomerVoiceFetchReset,
    reportRankingFetch,
    reportRankingFetchReset,
  })(FilterForm),
);
